import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { ROUTES } from 'utils/constants'

const OnlyLegalRoute = ({ component: Component, ...rest }) => {
	const user = useSelector(({ session }) => session)

	const hasLegalAccess =
		user?.hasLegalAccess || user?.is_admin || user?.is_company_admin

	return (
		<Route
			{...rest}
			render={(props) =>
				hasLegalAccess ? (
					<Component {...props} />
				) : (
					<Redirect to={ROUTES.demands} />
				)
			}
		/>
	)
}

export default OnlyLegalRoute
